import { publicApi } from "./api";

// One random id per browser tab, held in sessionStorage so it disappears when
// the visit ends. No cookie, nothing stored about the person, nothing that
// survives the tab closing — it exists only to count "visits" instead of hits.
const KEY = "cass_ask_visit";

const visitId = () => {
  try {
    let v = sessionStorage.getItem(KEY);
    if (!v) {
      v = Math.random().toString(36).slice(2) + Date.now().toString(36);
      sessionStorage.setItem(KEY, v);
    }
    return v;
  } catch {
    return "";
  }
};

export const trackAsk = (type, payload = {}) => {
  const visit = visitId();
  if (!visit) return;
  publicApi
    .askCassieTrack({ type, visit, path: window.location.pathname, ...payload })
    .catch(() => {});
};

// A view is counted once per page per visit: a back-button return to the hub
// isn't a new reader. Held in sessionStorage so a remount can't double-count.
const SEEN = "cass_ask_seen";
export const trackAskView = (page, payload = {}) => {
  const key = `${page}:${window.location.pathname}`;
  let seen = [];
  try {
    seen = JSON.parse(sessionStorage.getItem(SEEN) || "[]");
    if (seen.includes(key)) return;
    sessionStorage.setItem(SEEN, JSON.stringify([...seen, key].slice(-200)));
  } catch {
    /* private browsing — count the view rather than lose it */
  }
  trackAsk("view", { page, ...payload });
};

export default trackAsk;
